import ouiBase from '@goldwasserexchange/oui';
import * as React from 'react';
import { linkedBondsElementDetailsLabels } from '../../../../elements';
import { LinkedBondDetailLineLabelContainer } from './components';

export const LinkedBondDetailLineLabel = () => {
  const secondaryDimension = ouiBase.utils.dimensions.useCurrentSecondaryDimension();
  const Component = linkedBondsElementDetailsLabels[secondaryDimension];
  if (!Component) {
    return null;
  }
  return (
    <LinkedBondDetailLineLabelContainer>
      <Component />
    </LinkedBondDetailLineLabelContainer>
  );
};
